import template from './managed_departments_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class ManagedDepartmentsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ManagedDepartmentsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ManagedDepartmentsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ManagedDepartmentsHelp',
	dialog_class: ManagedDepartmentsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/managed_departments_help',
	provider: 'ps'
};
